export const HELP_ARTICLE_INFO = {
  formTitle: "Help Article",
  formTitleForNew: "New Help Article",
  path: "/helparticles",
  listPage: "/help-articles",
}

const STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "published", label: "Published" },
]

export const HELP_ARTICLE_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 2,
      fieldName: "helpArticle",
      fieldItems: [
        {
          label: "Category",
          type: "select",
          name: "helpCategory",
          required: false,
          initialFocus: false,
          url: "/helpcategoryoptions",
          validationProps: {
            required: "Category is required",
          }
        },
        {
          label: "Status",
          type: "select-sync",
          name: "status",
          required: false,
          initialFocus: false,
          options: STATUS_OPTIONS,
          defaultValue: "draft",
        },
        {
          label: "Title",
          type: "text",
          name: "title",
          initialFocus: true,
          validationProps: {
            required: "Title is required",
          }
        },
        {
          label: "Body (blank line = new paragraph; start a line with \"- \" for a bullet list, or \"1. \" for a numbered list)",
          type: "textarea",
          name: "body",
          initialFocus: false,
          validationProps: {
            required: "Body is required",
          }
        },
        {
          label: "Related Articles",
          type: "select",
          name: "relatedArticles",
          required: false,
          initialFocus: false,
          mutliselect: true,
          url: "/helparticleoptions",
        },
      ]
    },
  },
  watchFields: []
}
